const document = '["###.###.###-##", "##.###.###/####-##"]';
const cnpj = '##.###.###/####-##';
const cpf = '###.###.###-##';
const cep = "#####-###";
const date = '##/##/####';
const numeric = '#*';
const money = "#*.##";
const phone = '["(##) ####-####", "(##) #####-####"]';

export default {
    document,
    cnpj,
    cpf,
    cep,
    date,
    numeric,
    phone,
    money
}